import api from './api'

export const aiConfigApi = {
  // Model Config
  getConfigs: () => api.get('/ai/configs'),
  updateConfig: (serviceType, data) => api.put(`/ai/configs/${serviceType}`, data),
  quickSelect: (tier) => api.post('/ai/configs/quick-select', { tier }),
  getAvailableModels: () => api.get('/ai/models'),
  testModel: (modelId) => api.post('/ai/test', null, { params: { modelId } }),
  getProvider: () => api.get('/ai/provider'),

  // Usage Logs
  getUsageLogs: (params = {}) => api.get('/ai/usage', { params }),
  getUsageSummary: (params = {}) => api.get('/ai/usage/summary', { params }),
}